<template>
  <div>
    <v-container fluid>
      <v-row>
        <v-col cols="12">
          <v-card class="card--shadow">
            <vlu-list :townships="townships" :volunteers="volunteers" />
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import VluList from "@/components/volunteer/VluList";

import { mapState } from "vuex";

export default {
  components: {
    VluList,
  },
  computed: {
    ...mapState("Volunteer", ["volunteers"]),
    ...mapState("Township", ["townships"]),
  },
  created() {
    this.getData();
    this.$store.dispatch("Volunteer/getVolunteers");
    this.$store.dispatch("Township/getTownships");
  },
  methods: {
    getData() {
      let payload = {};
      if (this.$route.query.search) {
        payload.search = this.$route.query.search;
      }

      if (this.$route.query.startDate && this.$route.query.endDate) {
        payload.startDate = this.$route.query.startDate;
        payload.endDate = this.$route.query.endDate;

        if (this.$route.query.type) {
          payload.type = this.$route.query.type;
        }

        if (this.$route.query.training_type_id) {
          payload.training_type_id = this.$route.query.training_type_id;
        }
      }

      if (this.$route.query.dotsfromDate && this.$route.query.dotstoDate) {
        payload.dotsfromDate = this.$route.query.dotsfromDate;
        payload.dotstoDate = this.$route.query.dotstoDate;

        if (this.$route.query.township_id) {
          payload.township_id = this.$route.query.township_id;
        }
      }

      this.$store.dispatch("Volunteer/getVolunteers", payload);
    },
  },
  watch: {
    $route() {
      this.getData();
    },
  },
};
</script>

<style scoped>
.card--shadow {
  box-shadow: var(--primary-box-shadow) !important;
}
</style>
